var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9033_5409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.875 15.7188C17.875 15.7812 17.8438 15.8438 17.8125 15.9375C16.6875 18.8125 14.4062 21.0938 11.5625 22.25L11.0312 22.4688C10.9688 22.5 10.875 22.4688 10.8125 22.4375C10.75 22.375 10.7188 22.3125 10.7188 22.2188C10.7812 20.7812 11.1562 17.4062 9.53125 14.0938C9.71875 13.8438 9.84375 13.5625 9.90625 13.25C10 12.7812 9.9375 12.125 9.15625 11.5C9.03125 11.4062 8.84375 11.4375 8.75 11.5312C8.71875 11.5938 8.6875 11.6875 8.71875 11.75C8.71875 11.8125 8.75 11.875 8.8125 11.9375C9.25 12.2812 9.46875 12.6875 9.375 13.1562C9.34375 13.2812 9.28125 13.4062 9.21875 13.5312C9.0625 13.8438 8.8125 14.125 8.53125 14.3438C8.46875 14.375 8.4375 14.4062 8.375 14.4375C8.21875 14.5312 8.03125 14.625 7.84375 14.6875C7.21875 14.9062 6.53125 14.5 6.21875 14.3438H6.1875C6.15625 14.3438 6.125 14.375 6.125 14.4062C6.125 14.4062 6.125 14.4062 6.125 14.4375C6.15625 14.6562 6.125 14.875 6.03125 15.0625C6.03125 15.125 6 15.1562 6 15.1875C5.90625 15.3438 5.78125 15.5 5.625 15.5938C5.625 15.5938 5.59375 15.5938 5.59375 15.625C5.375 15.75 5.125 15.8438 4.875 15.8438C4.28125 15.8438 3.84375 15.625 3.5625 14.75C3.46875 14.5312 3.46875 14.2812 3.5625 14.0625C3.5625 14.0625 3.5625 14.0625 3.5625 14.0312C3.59375 13.9375 3.65625 13.8438 3.71875 13.75L5.21875 11.9375C5.25 11.9062 5.25 11.875 5.28125 11.8438C5.3125 11.75 5.34375 11.625 5.3125 11.5L5.25 11.0938C5.25 11.0312 5.25 11 5.25 10.9375H5.28125C5.28125 10.9062 5.28125 10.875 5.3125 10.875L6.1875 9.78125C6.21875 9.75 6.21875 9.71875 6.25 9.6875C6.34375 9.5 6.34375 9.25 6.1875 9.0625C6.125 8.96875 5.53125 8.25 5.34375 8.0625C5.34375 8.03125 5.34375 8.03125 5.34375 8C5.34375 8 5.34375 7.96875 5.375 7.96875C6.03125 7.625 7.4375 7.65625 8.1875 8.46875C8.28125 8.5625 8.40625 8.59375 8.5 8.53125C10.1562 7.90625 13 8.625 14.2812 10.2188C14.2812 10.25 14.2812 10.2812 14.2812 10.3125C14.25 10.3438 14.2188 10.3438 14.1875 10.3438C13.8125 10.25 13.375 10.2812 13.0312 10.4375C13 10.4688 13 10.4688 13 10.4688C13.4375 10.6875 15.5938 11.4062 16.3125 12.375C16.3125 12.4062 16.3438 12.4375 16.3125 12.4688C16.3125 12.5 16.2812 12.5312 16.2188 12.5312C15.8125 12.5 15.375 12.5938 14.9688 12.75L14.9375 12.7812H14.9688C15.5938 13 16.1562 13.375 16.5938 13.9062C17.0938 14.4375 17.5312 15.0625 17.875 15.7188Z",
    fill: "#FF82EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9033_5409",
    x: -6.53125,
    y: -2.375,
    width: 34.4062,
    height: 34.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.509804 0 0 0 0 0.921569 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9033_5409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9033_5409",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorse);
export default ForwardRef;